import { CustomCron } from '@components/ui-cron/cron.models';
import {
    IFilterValueMap,
    IProcess,
    JobStartStrategy,
} from '@models';
import { ITriggerStopAfter } from '@pages/triggers/upsert/trigger.upsert.page.models';
import {
    ISuggestValue,
    ISuggestValueData,
} from '@uipath/angular/components/ui-suggest/models';

export enum TriggerType {
    Time = 1,
    Queue,
}

export interface ITriggerCommon {
    id?: number;
    name: string;
    enabled: boolean;
    startStrategy: number;
}

export interface IQueueTrigger {
    queue?: ISuggestValue[];
    /** The minimum number of queue items that should trigger the process activation. */
    itemsActivationThreshold: number;
    /** The target ratio between the number of queue items and the Total number of jobs created by a process. */
    itemsPerJobActivationTarget: number;
    /** The maximum number of jobs that a process can create as result of a Queue driven activation. */
    maxJobsForActivation: number;
}

export interface ITriggerUpsert extends ITriggerCommon, IQueueTrigger, ITriggerStopAfter {
    type: TriggerType;

    process: ISuggestValueData<IProcess>[];
    inputArguments: Record<string, any> | null;
    startStrategyRadio: JobStartStrategy;
    executorRobots: { id: number }[];

    timezone: ISuggestValue[];
    useCalendar: boolean;
    calendar?: ISuggestValue[];

    disableAfter: boolean;
    stopProcessDate: any | null;

    externalJobKey: string;
    environmentId: number;

    // FIXME: cron
    startProcessCron: string;
    startProcessCronDetails: any;
    startProcessCronObj?: CustomCron;
}

export interface ITriggerGrid extends ITriggerCommon {
    id: number;
    queueDefinitionId: number;
    queueDefinitionName: string;
    packageName: string;
    environmentName: string;
    startProcessCronSummary: string | null;
    startProcessNextOccurrence: Date | null;
    stopProcessExpression: string;
    timezoneIana: string;
}

export enum StopStrategy {
    SoftStop = 'SoftStop',
    Kill = 'Kill',
}

export const TRIGGER_TYPE_FILTER: IFilterValueMap<typeof TriggerType, ITriggerGrid> = {
    Queue: [{
        property: 'queueDefinitionId',
        method: 'ne',
        value: null,
    }],
    Time: [{
        property: 'queueDefinitionId',
        method: 'eq',
        value: null,
    }],
};
